import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Cookies from "js-cookie";

export const customerApi = createApi({
  reducerPath: "customerApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BASE_URL}`,
    prepareHeaders: (headers, { getState }) => {
      const { auth } = getState();
      const token = auth.user.token;
      headers.set("Authorization", `Bearer ${token}`);
      headers.set("Content-Type", `application/json;charset=UTF-8`);
      return headers;
    },
  }),
  tagTypes: ["customers", "tilesData"],
  endpoints: (builder) => ({
    customers: builder.query({
      query: (data) => {
        return {
          url: "/Customer/GetCustomersInt",
          method: "GET",
          params: data,
        };
      },
      providesTags: ["customers"],
    }),
    singleCustomer: builder.query({
      query: (data) => {
        return {
          url: "/Customer/GetCustomersInt",
          method: "GET",
          params: data,
        };
      },
    }),
    createCustomer: builder.mutation({
      query: (data) => {
        return {
          url: "/Customer/CreateCustomers",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["customers"],
    }),
    updateCustomer: builder.mutation({
      query: (data) => {
        return {
          url: "/Customer/UpdateCustomers",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["customers"],
    }),
    countryCode: builder.query({
      query: (data) => {
        return {
          url: "/Customer/CountryCodes",
          method: "GET",
          params: data,
        };
      },
    }),
    changeStatus: builder.mutation({
      query: (data) => {
        return {
          url: `/Customer/UpdateCustomerStatus`,
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["customers"],
    }),
    deleteCustomer: builder.mutation({
      query: (data) => {
        return {
          url: `/Customer/DeleteCustomer?keyID=${data.keyID}&Type=${data.Type}`,
          method: "POST",
        };
      },
      invalidatesTags: ["customers"],
    }),
  }),
});

export const {
  useCustomersQuery,
  useSingleCustomerQuery,
  useCreateCustomerMutation,
  useUpdateCustomerMutation,
  useCountryCodeQuery,
  useChangeStatusMutation,
  useDeleteCustomerMutation,
} = customerApi;
